import React from "react";

const DashboardTitle = ({ title }) => {
  return <div className="flex font-semibold text-xl p-2">{title} </div>;
};

export default DashboardTitle;
